import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';
import { AmlHitUpdate, AmlReport } from '@wdx/clmi/clmi-swagger-gen';

@Injectable()
export class AmlReportsService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);


    getAmlReportForAppStatus(appStatusId: string): Observable<AmlReport> {
        return this.http.get<AmlReport>(
            `${
                this.config.getConfiguration().API_BASE
            }/appstatus/${appStatusId}/aml`,
        );
    }

    runAmlReportForAppStatus(appStatusId: string): Observable<AmlReport> {
        return this.http.patch<AmlReport>(
            // eslint-disable-next-line max-len
            `${
                this.config.getConfiguration().API_BASE
            }/appstatus/${appStatusId}/aml`,
            {},
        );
    }

    updateAmlHitForAppStatus(amlHit: AmlHitUpdate): Observable<AmlHitUpdate> {
        return this.http.post<AmlHitUpdate>(
            `${this.config.getConfiguration().API_BASE}/appstatus/amlhit`,
            amlHit,
        );
    }
}
